// Mirrors backend/stripe_billing.py: yearly = 12 months at 20% off, charged once a year (whole dollars).
export const YEARLY_DISCOUNT = 0.20;
export const YEARLY_DISCOUNT_PCT = Math.round(YEARLY_DISCOUNT * 100);
export const yearlyPrice = (monthly) => Math.round(monthly * 12 * (1 - YEARLY_DISCOUNT));
export const yearlyPerMonth = (monthly) => Math.round(yearlyPrice(monthly) / 12);
export const isYearly = (interval) => interval === 'year' || interval === 'yearly';
export const intervalFromQuery = (search = window.location.search) => {
  const b = (new URLSearchParams(search).get('billing') || '').toLowerCase();
  return b === 'year' || b === 'yearly' || b === 'annual' ? 'year' : 'month';
};
export const priceLabel = (monthly, interval) => (isYearly(interval)
  ? `$${yearlyPrice(monthly).toLocaleString()}/yr`
  : `$${monthly.toLocaleString()}/mo`);
